import "./index.scss";
import React, { useEffect, useRef, useState } from "react";
import { Button, ConfigProvider, Modal, Table } from "antd";
import Draggable from "react-draggable";
import zhCN from "antd/lib/locale/zh_CN";
import wrapper from "../EleStandardDrawer/wrapper";

const DefaultFieldDrawer = (props) => {
  const [visible, setVisible] = useState(true);
  const {
    title = "新增数据元",
    onCancel,
    closeDialog,
    noBtn,
    maskClosable,
    elementData = [],
    onOk,
  } = props;

  const [selectedRowList, setSelectedRowList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });

  const draggleRef = useRef(null);
  const refTable = useRef(null);

  const getRowKey = (record) =>
    record?.data_ele_id ?? record?.id ?? record?.col_id ?? record?.col_name;

  useEffect(() => {
    const keys = elementData?.map((item) => getRowKey(item)).filter(Boolean);
    setSelectedRowList(elementData || []);
    setSelectedRowKeys(keys || []);
  }, [elementData]);

  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  const columns = [
    {
      title: "中文名称",
      dataIndex: "col_cmnt",
    },
    {
      title: "字段名",
      dataIndex: "col_name",
    },
    {
      title: "字段类型",
      dataIndex: "col_data_type_code_value",
    },
    {
      title: "长度",
      dataIndex: "col_length",
    },
    {
      title: "小数位",
      dataIndex: "col_scale",
    },
    {
      title: "描述",
      dataIndex: "data_ele_desc",
    },
  ];

  const handleCancel = () => {
    onCancel && onCancel();
    setVisible(false);
    setTimeout(() => {
      closeDialog();
    }, 500);
  };

  const rowSelection = {
    selectedRowKeys,
    onSelect: (record, selected) => {
      const key = getRowKey(record);
      if (!key) return;
      if (selected) {
        setSelectedRowKeys((before) => [...before, key]);
        setSelectedRowList((before) => [...before, record]);
      } else {
        setSelectedRowKeys((before) => before?.filter((el) => el !== key));
        setSelectedRowList((before) =>
          before?.filter((el) => getRowKey(el) !== key)
        );
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const changeKeys = changeRows
        ?.map((item) => getRowKey(item))
        .filter(Boolean);
      if (!changeKeys) return;
      if (selected) {
        setSelectedRowKeys((before) => [...before, ...changeKeys]);
        setSelectedRowList((before) => [...before, ...changeRows]);
      } else {
        setSelectedRowKeys((before) =>
          before?.filter((el) => changeKeys.indexOf(el) === -1)
        );
        setSelectedRowList((before) =>
          before?.filter((el) => changeKeys.indexOf(getRowKey(el)) === -1)
        );
      }
    },
  };

  const handleOk = () => {
    const data = selectedRowList?.map((item) => ({
      col_desc: item.col_cmnt,
      col_name: item.col_name,
      col_length: item.col_length,
      col_scale: item.col_scale,
      col_type_code: item.col_data_type_code,
      not_null_flag: false,
      pk_flag: false,
      auto_inc_flag: false,
      def_value: "",
      status: true,
    }));
    onOk && onOk(data);
    setVisible(false);
    setTimeout(() => {
      closeDialog();
    }, 500);
  };

  return (
    <ConfigProvider locale={zhCN}>
      <Modal
        title={title}
        visible={visible}
        onCancel={handleCancel}
        wrapClassName="EleStandardDrawer DefaultFieldDrawer"
        centered
        footer={null}
        maskClosable={maskClosable}
        width={1200}
        onMouseOver={() => {
          if (disabled) {
            setDisabled(false);
          }
        }}
        onMouseOut={() => {
          setDisabled(true);
        }}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <div className="addModalContent">
          <div
            className="tableContent"
            style={{ width: "100%" }}
            ref={refTable}
          >
            <Table
              className="myFormTable"
              rowSelection={rowSelection}
              dataSource={elementData}
              pagination={false}
              columns={columns}
              rowKey={(record) => getRowKey(record)}
              scroll={{
                y: "500px",
              }}
            />
          </div>

          {!noBtn && (
            <div className="drawerFooterBtnBox btnBox">
              <Button
                className="noBg"
                onClick={() => {
                  handleCancel();
                }}
              >
                关闭
              </Button>
              <Button
                onClick={() => {
                  handleOk();
                }}
                style={{
                  background: "#006AB2",
                  color: "#fff",
                  borderColor: "#006AB2",
                }}
              >
                确定
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default wrapper(DefaultFieldDrawer);
